import Vue from "vue";
import VueRouter from "vue-router";
import stores from "../store"
// import Hero from '../components/landing/Hero';
// import GifImage from '../assets/img/landing-anim.gif'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "landing",
    component: () =>
      import(/* webpackChunkName: "landing" */ "../views/Landing.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    component: () =>
      import(/* webpackChunkName: "landing" */ "../views/Terms.vue"),
  },
  {
    path: "/stats",
    name: "stats",
    component: () =>
      import(/* webpackChunkName: "landing" */ "../views/Stats.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () =>
      import(
        /* webpackChunkName: "register" */ "../views/user/auth/Register.vue"
      ),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () =>
      import(
        /* webpackChunkName: "forgot-password" */ "../views/user/auth/ForgotPW.vue"
      ),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () =>
      import(
        /* webpackChunkName: "reset-password" */ "../views/user/auth/ResetPW.vue"
      ),
  },
  {
    path: "/auth-ip",
    name: "auth-ip",
    component: () =>
      import(
        /* webpackChunkName: "reset-password" */ "../views/user/misc/AuthIP.vue"
      ),
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/user/auth/Login.vue"),
  },
  {
    path: "/discord-redirect",
    name: "discord-redirect",
    component: () =>
      import(/* webpackChunkName: "discord-redirect" */ "../views/user/misc/DiscordRedirect.vue"),
  },
  {
    path: "/discord-redirect-login",
    name: "discord-redirect-login",
    component: () =>
      import(/* webpackChunkName: "discord-redirect-login" */ "../views/user/misc/DiscordRedirectLogin.vue"),
  },
  {
    path: "/google-redirect",
    name: "google-redirect",
    component: () =>
      import(/* webpackChunkName: "discord-redirect" */ "../views/user/misc/GoogleRedirect.vue"),
  },
  {
    path: "/google-redirect-login",
    name: "google-redirect-login",
    component: () =>
      import(/* webpackChunkName: "discord-redirect-login" */ "../views/user/misc/GoogleRedirectLogin.vue"),
  },
  {
    path: "/confirmation",
    name: "confirmation",
    component: () =>
      import(/* webpackChunkName: "confirmation" */ "../views/user/misc/confirmation.vue"),
  },
  {
    path: "/two-fa",
    component: () =>
      import(
        /* webpackChunkName: "two-fa" */ "../views/user/auth/TwoAuth.vue"
      ),
    meta: {
      requiresAuth: true,
      requiresVerification: true,
    },
  },
  {
    path: "/stripe-redirect",
    component: () =>
      import(
        /* webpackChunkName: "stripe-redirect" */ "../views/user/misc/StripeRedirect.vue"
      ),
    meta: {
      requiresAuth: true,
      requiresVerification: true,
    },
  },
  {
    path: "/user",
    component: () =>
      import(
        /* webpackChunkName: "user" */ "../views/user/dashboard/Main.vue"
      ),
    meta: {
      requiresAuth: true,
      requiresVerification: true,
    },
    children: [
      {
        path: "dashboard",
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ "../views/user/dashboard/Dashboard.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "captcha/settings",
        component: () =>
          import(
            /* webpackChunkName: "captcha-settings" */ "../views/user/dashboard/Captcha/Solving.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "captcha/solving",
        component: () =>
          import(
            /* webpackChunkName: "captcha-solving" */ "../views/user/dashboard/Captcha/Captcha.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "captcha/factories",
        component: () =>
          import(
            /* webpackChunkName: "captcha-factories" */ "../views/user/dashboard/Captcha/Factories.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "captcha/solving-stats",
        component: () =>
          import(
            /* webpackChunkName: "captcha-stats" */ "../views/user/dashboard/Captcha/SystemStats.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "funds",
        component: () =>
          import(
            /* webpackChunkName: "funds" */ "../views/user/dashboard/Funds.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "settings/api",
        component: () =>
          import(
            /* webpackChunkName: "settings-api" */ "../views/user/dashboard/ProfileSettings/Api.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "settings/account",
        component: () =>
          import(
            /* webpackChunkName: "settings-account" */ "../views/user/dashboard/ProfileSettings/Account.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "settings/security",
        component: () =>
          import(
            /* webpackChunkName: "settings-security" */ "../views/user/dashboard/ProfileSettings/Security.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "tools",
        component: () =>
          import(
            /* webpackChunkName: "tools" */ "../views/user/dashboard/Tool/Tools.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      // {
      //   path: "tools/sponsored",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "tools-sponsored" */ "../views/user/dashboard/Tool/Sponsored.vue"
      //     ),
      //   meta: {
      //     requiresAuth: true,
      //     requiresVerification: true,
      //   },
      // },
      {
        path: "tools/bots",
        component: () =>
          import(
            /* webpackChunkName: "tools-bots" */ "../views/user/dashboard/Tool/Bots.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "tools/libraries",
        component: () =>
          import(
            /* webpackChunkName: "tools-libs" */ "../views/user/dashboard/Tool/Library.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "referrals",
        component: () =>
          import(
            /* webpackChunkName: "register" */ "../views/user/dashboard/Referrals.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "partners",
        component: () =>
          import(
            /* webpackChunkName: "register" */ "../views/user/dashboard/Partners.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "help",
        component: () =>
          import(
            /* webpackChunkName: "help" */ "../views/user/dashboard/Help/Help.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "help/captchas",
        component: () =>
          import(
            /* webpackChunkName: "help-c" */ "../views/user/dashboard/Help/Captcha.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "help/payments",
        component: () =>
          import(
            /* webpackChunkName: "help-p" */ "../views/user/dashboard/Help/Payments.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "help/api-docs",
        component: () =>
          import(
            /* webpackChunkName: "help-api-docs" */ "../views/user/dashboard/Help/ApiDocs.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "help/referrals",
        component: () =>
          import(
            /* webpackChunkName: "help-referrals" */ "../views/user/dashboard/Help/Referrals.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "help/accounts",
        component: () =>
          import(
            /* webpackChunkName: "accounts" */ "../views/user/dashboard/Help/Accounts.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "help/others",
        component: () =>
          import(
            /* webpackChunkName: "help-others" */ "../views/user/dashboard/Help/Others.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
      {
        path: "support",
        component: () =>
          import(
            /* webpackChunkName: "support" */ "../views/user/dashboard/Support.vue"
          ),
        meta: {
          requiresAuth: true,
          requiresVerification: true,
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(
      (record) => record.meta.requiresVerification && record.meta.requiresAuth
    )
  ) {
    //let isVerified = stores.state.userStore.verified;
    let isLoggedIn = stores.state.userStore.loggedIn;
    if (!isLoggedIn) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
    // else if (!isVerified) {
    //   next({
    //     path: "/not-verified",
    //     query: {
    //       redirect: to.fullPath,
    //     },
    //   });
    // }
    else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    let isAuth = stores.state.userStore.loggedIn;
    if (!isAuth) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
